export default __webpack_public_path__ + "static/media/unnamed_clock_white.2ae56486.svg";